import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessagesSidebar = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M17.1163 8.44605C17.8261 9.20875 18.25 10.1733 18.25 11.2222C18.25 12.0243 17.8927 12.8637 17.3543 13.5597C16.2579 14.977 15.7095 15.6858 15.6164 15.883C15.4612 16.2116 15.5027 16.0759 15.4478 16.4351C15.4149 16.6507 15.4362 16.9748 15.4788 17.623L15.52 18.25C15.52 18.25 13.2859 15.6944 13 15.6944C11.9708 15.6944 11.0107 15.4422 10.2004 15.0062M14.25 7C14.25 9.8995 11.4518 12.25 8 12.25C7.65963 12.25 5 15.25 5 15.25L5.07803 14.0795C5.12741 13.3389 5.15209 12.9686 5.10927 12.7283C5.0453 12.3693 5.07014 12.4399 4.89524 12.1199C4.77816 11.9057 4.22403 11.3026 3.11581 10.0965C2.31121 9.22084 1.75 8.08148 1.75 7C1.75 4.10051 4.54822 1.75 8 1.75C11.4518 1.75 14.25 4.10051 14.25 7Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgMessagesSidebar);
export { ForwardRef as ReactComponent };
